export default __webpack_public_path__ + "static/media/hht1_ani_18.ff60ff29.png";